export default __webpack_public_path__ + "static/media/hero-evilbackground.c0e01914.webp";